import React from 'react';
import { PackagePlus, PackageMinus, MapPin, Flag, Fuel } from 'lucide-react';
import { KpiTile } from '@/components/transport/DashboardBits';

export const fmtMin = (m) => {
  if (m == null) return '—';
  if (m < 1) return '<1m';
  const t = Math.round(m), h = Math.floor(t / 60), mm = t % 60;
  return h > 0 ? `${h}h ${mm}m` : `${mm}m`;
};

export const ReportKpis = ({ lu, fe }) => {
  const s = lu?.summary || {};
  const kmpl = fe?.fleet?.kmpl;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-4" data-testid="report-kpis">
      <KpiTile label="Avg loading (Ready → Start)" value={fmtMin(s.load_trip?.avg_min)} icon={PackagePlus} accent="blue" testId="rk-avg-loading" />
      <KpiTile label="Avg unloading (End → Complete)" value={fmtMin(s.unload_trip?.avg_min)} icon={PackageMinus} accent="indigo" testId="rk-avg-unloading" />
      <KpiTile label="Avg time at a pickup stop" value={fmtMin(s.load_stop?.avg_min)} icon={MapPin} accent="teal" testId="rk-avg-pickup-stop" />
      <KpiTile label="Avg time at a drop stop" value={fmtMin(s.unload_stop?.avg_min)} icon={Flag} accent="slate" testId="rk-avg-drop-stop" />
      <KpiTile label="Fleet Km/L (fuel odometer)" value={kmpl != null ? kmpl : '—'} icon={Fuel} accent="amber" testId="rk-fleet-kmpl" />
    </div>
  );
};
